require('ExceptionHandler')
.define('UserInfo',function (imports) {

  var user_info = {};
  var _ready = false;
  var ExceptionHandler = imports.ExceptionHandler;
  var listeners = [];

  function current_user_info() {
    return user_info;
  }

  function is_logged_in() {
    return _ready && user_info && user_info.logged_in;
  }

  function ready() {
    return _ready;
  }

  function reset() {
    _ready = false;
  }

  function data() {
    return user_info;
  }

  function on_data_ready(callback) {
    if (_ready) {
      callback(user_info);
    }
    else {
      listeners.push(callback);
    }
  }


  function retrieve_data(callback) {
    if(_ready){
      return callback(user_info);
    }
    var params;
    if ($("#target_auction_ids").length > 0 ) {
      params = { target_auction_ids : $("#target_auction_ids").val() };
    }
    else if ($('.cw_search-result-favourite').length > 0 ) {
      var favorable_lot_ids = $('.cw_search-result-favourite[data-lot_id]').map(function(){
        return $(this).data('lot_id');
      }).get().join(',');
      params = { search_results_lot_ids : favorable_lot_ids };
    }
    else if ($('body.cw-exceptional_lots_page .cw_favourite').length > 0) {
      var new_lots = $('.cw-exceptional_lots_page .cw_favourite[data-lot_id]:not(".js-favorites-loaded")');
      new_lots.addClass('js-favorites-loaded');
      var new_lot_ids = new_lots.map(function(){
        return $(this).data('lot_id');
      }).get().join(',');
      params = { search_results_lot_ids : new_lot_ids };
    }
    else {
      params = { auction_id : $("#auction_id").val() };
    }

    $.get("/veilingen/user_info", params, function(data) {
        user_info = data;
        _ready = true;
        if (data.enable_full_exception_logging) {
          ExceptionHandler.instance().setFullLoggingEnabled(true);
        }
        if (callback) {callback(data);}
        for (var i = 0; i < listeners.length; i++) {
          listeners[i](data);
        }
    });
  }

  return {
    retrieve_data: retrieve_data,
    ready : ready,
    reset: reset,
    current_user_info : current_user_info,
    data : data,
    is_logged_in : is_logged_in,
    on_data_ready: on_data_ready
  };
});
